import { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import config from "../../config";
import { useLanguage } from "../../Context";

export default function VideoSubcat() {
  const { subcategory } = useParams();
  const [contents, setContents] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [isLatestLoading, setIsLatestLoading] = useState(true);
  const [latestContent, setLatestContent] = useState([]);
  const [latestId, setLatestId] = useState(null);

  const { language } = useLanguage();

  // Fetch latest video and set latestId
  useEffect(() => {
    const fetchLatestVideo = async () => {
      const response = await fetch(
        `${config.apiUrl}contentapi.php?option=1&type=7&categoryid=1&subcategory=${subcategory}&limitCount=1&lang=${language}`
      );
      const latestVideo = await response.json();
      setLatestContent(latestVideo);
      setLatestId(latestVideo[0]?.id || null);
      setIsLatestLoading(false);
    };
    fetchLatestVideo();
    setPage(1);
    setContents([]);
    setHasMore(true);
  }, [language, subcategory]);

  // Fetch data when latestId or page changes
  useEffect(() => {
    if (latestId === null) return;
    const fetchData = async () => {
      if (!hasMore) return;

      setIsLoading(true);

      try {
        const response = await fetch(
          `${config.apiUrl}lazyLoad.php?option=2&categoryid=1&subcategory=${subcategory}&page=${page}&lang=${language}&id=${latestId}`
        );
        const data = await response.json();
        const newContents = data.map((item) => ({
          id: item.id,
          categoryE: item.categoryE,
          FileUrl: item.FileUrl,
          ImageUrl: item.ImageUrl,
          PostDate: item.PostDate,
          ShortDesc: item.ShortDesc,
          SubCategory: item.SubCategory,
          SubCategoryd: item.SubCategoryd,
          Title: item.Title,
          YoutubeUrl: item.YoutubeUrl,
          contentViews: item.contentViews,
          fulldesc: item.fulldesc,
        }));
        setContents((prev) => [...prev, ...newContents]);
        setHasMore(newContents.length > 0);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
    // eslint-disable-next-line
  }, [latestId, page, language, subcategory]);

  const handleScroll = () => {
    const scrollOffset = 200;
    const isBottom =
      window.innerHeight + window.scrollY + scrollOffset >=
      document.documentElement.scrollHeight;
    if (isBottom && !isLoading && hasMore) {
      setPage((prev) => prev + 1);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
    // eslint-disable-next-line
  }, [isLoading, hasMore]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [page]);

  const styles = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(15rem, 2fr))",
    gap: "1rem",
  };

  const allVideo = contents.map((video) => (
    <div
      key={video.id}
      className="card bg-body-secondary border-0 rounded-1 mb-4"
    >
      <Link
        to={`/video/${video.SubCategory}/${video.id}`}
        className="icon-links blue-links text-body"
      >
        <div className="ratio ratio-16x9">
          <img
            src="/img/arrow-w.png"
            className="position-absolute m-2"
            alt=""
            style={{
              width: "2.5rem",
              height: "2.5rem",
              zIndex: "10",
              right: "0",
            }}
          />
          <img
            className="w-100 h-100 object-fit-cover"
            src={video.ImageUrl?.replace(
              /_large(?=\.(jpg|jpeg|png)$)/,
              "_thumb"
            )}
            alt="video thumbnails"
          />
        </div>
        <p className="fs-6 m-0 text-center p-3">{video.Title}</p>
      </Link>
    </div>
  ));

  const latestVideo = latestContent.map((video) => (
    <div
      key={video.id}
      className="d-flex flex-column flex-lg-row bg-body-secondary mt-4 mb-4"
    >
      <Link
        to={`/video/${video.SubCategory}/${video.id}`}
        className="col-lg-6 latest-heigth"
        style={{ position: "relative" }}
      >
        <img
          src="/img/arrow.png"
          alt=""
          className="icon-links"
          style={{
            width: "15%",
            position: "absolute",
            left: "0",
            right: "0",
            top: "0",
            bottom: "0",
            margin: "auto",
          }}
        />
        <img
          className="w-100 h-100 object-fit-cover"
          src={video.ImageUrl}
          alt=""
          style={{ maxHeight: "25em" }}
        />
      </Link>
      <div className="col-lg-6 p-3 secondary-bg-yellow">
        <h2 className="border-end border-5 pe-2 text-light" id="border-light">
          {video.Title}
        </h2>
        <p>{video.ShortDesc}</p>
      </div>
    </div>
  ));

  return (
    <div className="bg-body">
      <div className="max-container-width py-3 text-body">
        {isLatestLoading ? (
          <div className="d-flex flex-column flex-lg-row bg-body-secondary mt-4 mb-4">
            <div
              className="col-lg-6 bg-body-tertiary"
              style={{ minHeight: "38vh" }}
            />
            <div
              className="col-lg-6 p-3"
              style={{ backgroundColor: "#ffae00" }}
            >
              <div className="placeholder-glow">
                <span
                  className="placeholder col-12 mb-3 text-white"
                  style={{ height: "1.8rem" }}
                />
                <span
                  className="placeholder col-6 mb-3 text-white"
                  style={{ height: "1.8rem" }}
                />
                <span className="placeholder col-12 mb-3" />
                <span className="placeholder col-12 mb-3" />
                <span className="placeholder col-12 mb-3" />
                <span className="placeholder col-8 mb-3" />
              </div>
            </div>
          </div>
        ) : (
          latestVideo
        )}
        <div style={styles}>{allVideo}</div>
        {isLoading && (
          <div className="placeholder-glow mb-4" style={styles}>
            {[...Array(5)].map((_, index) => (
              <div key={index} className="bg-body-secondary">
                <div className="w-100 placeholder" style={{ height: "7rem" }} />
                <div className="p-3">
                  <div className="col-12 placeholder" />
                  <div className="col-6 placeholder" />
                </div>
              </div>
            ))}
          </div>
        )}
        {!hasMore && (
          <div className="mt-5 text-center">
            <small className="p-2 bg-secondary text-light rounded">
              {parseInt(language) === 1 ? "پایان مطالب" : "د محتوا پای"}
            </small>
          </div>
        )}
      </div>
    </div>
  );
}
